module.exports = __webpack_public_path__ + "static/media/clear-filter.b514e574.svg";